import {FACTIONS} from "../../../constants/factions";

export const SPIRITS_QUOTES = [{
  quote: 'Где ваша история — там наши дома. Где наши дома — там ваши могилы',
  author: 'Манлий Сумрачный, дух-жрец Порушенных алтарей',
  factionId: FACTIONS.SPIRITS
}, {
  quote: 'Не просите духов. Камни помнят больше, чем летописи. А духи старше камней',
  author: 'Пилат Кассийский, историк и философ Вольных городов',
  factionId: FACTIONS.SPIRITS
}, {
  quote: 'Вы уходите. Мы остаёмся. И ждём следующего, кто придёт',
  author: 'Тит Туманный, дух-хранитель Заросшего тракта',
  factionId: FACTIONS.SPIRITS
}]